<template>
  <div class="mxMobileContent">
    <div class="content-top">
      <div class="title">{{ $t("mxHarmonyTitle") }}</div>
      <div class="desc">{{ $t("mxLongContent") }}</div>
      <div class="code-container">
        <!-- hormonyosCode -->
        <canvas ref="hormonyosCode"></canvas>
        <img
          class="mxScanIcon"
          src="../assets/downloadImg/logo2.png"
          style="margin-top: -7.5px;"
          alt=""
        />
      </div>
      <div class="scan-hint">{{ $t("mx.scanCodeDown") }}</div>
      <div class="common-btn android-download" @click="downloadAndroidMX">{{ $t("mx.androidDownload") }}</div>
      <div class="common-btn harmony-download" @click="downloadHarmonyMX">{{ $t("mx.harmonyDownload") }}</div>
      <div class="remark">如纯血鸿蒙版本有尚未支持功能, 可安装卓易通版本使用</div>
    </div>
    
    <div class="add-group" @click="openAddGroupTips">{{ $t("mx.hormony_group") }}</div>
    
    <el-dialog
      :title="$t('mx.hormony_group')"
      :visible.sync="dialogVisible"
      width="80%">
      <div class="dialog_content">
        <div class="qrcode_group">
          <img
            class="group-code"
            src="../assets/downloadImg/harmony-group.png"
            alt=""
          />
          <img class="qrcode_icon" src="../assets/downloadImg/logo2.png" alt="" />
        </div>
        <div class="tips">{{ $t('mx.harmonyScan') }}</div>
        <div class="group-num">
          <div>{{ groupNum }}</div>
          <img
            class="copy-btn"
            src="../assets/downloadImg/copy.png"
            @click="onCopy"
          />
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import QRCode from "qrcode";
import CopyGroupnumber from "./js/copy-groupnumber";
import { getApiConfig } from "@/mx-service/libs/http/config";
import { is4aLogin } from "@/mx-service/libs/utils";
import device from "@/mx-service/libs/utils/device";

export default {
  mixins: [CopyGroupnumber],
  data(){
    return {
      hormonyOSCodeData: getApiConfig().hormonyOSDownloadUrl,
      dialogVisible: false,
      mxDownList: [],
      qrHormonyCodeOptions: {
        width: 183,
        height: 183,
      },
    }
  },
  methods: {
    // 下载安卓美信
    async downloadAndroidMX(downloadParamId) {
      if (device.isMission()) {
        this.$MdMessage({
          message: '请在系统浏览器中打开链接进行下载',
          type: 'warning',
        });
        return;
      }
      if (device.isWechat()) {
        this.$emit("showWX", true);
        return;
      }
      if (device.isWechat()) {
        this.$emit("showWX", true);
        return;
      }
      console.log("downloadParamId---", downloadParamId);
      const type = "MeiXin_Android_Link";
      const status = await is4aLogin(type, true);
      console.log("download-status", status);
      if (!status) return;
      const data = this.mxDownList.filter((item) => item.paramId === type)[0];
      window.location.href = data.paramValue;
    },
    // 下载纯血鸿蒙美信
    downloadHarmonyMX() {
      const userAgent = window.navigator.userAgent;
      if(userAgent.toLowerCase().includes('mideaConnect')) {
        mx.openSysBrowser([this.hormonyOSCodeData]).then(function (success) {
          console.log(success);
        })
      } else {
        window.location.href = this.hormonyOSCodeData;
      }
    },
    openAddGroupTips(){
      this.dialogVisible = true
    },
    async isDownloading() {
      const downloadParamId = this.$route.query.id;
      if (
        (await is4aLogin()) &&
        downloadParamId &&
        downloadParamId.toLowerCase().includes("meixin")
      ) {
        this.downloadAndroidMX(downloadParamId);
      }
    },
    async getData() {
      const data = await mx.request("getMobileUrl");
      return data;
    },
  },
  async mounted(){
    const isMobile = device.isMobile();

    // 判断单点登录状态
    const status = await is4aLogin();
    console.log("MX 移动端 mounted-status", status);
    if (
      (status &&
        isMobile &&
        window.location.pathname.indexOf("pcv5-4a.html") > -1) ||
      device.isMission()
    ) {
      this.mxDownList = await this.getData();
      this.qrCodeData =
        this.mxDownList &&
        this.mxDownList.length > 0 &&
        this.mxDownList.filter((item) => item.paramId === 'MeiXin_Android_Link')[0].paramValue;
    }

    // 判断是否有下载进程
    await this.isDownloading();

    QRCode.toCanvas(
      this.$refs.hormonyosCode,
      this.hormonyOSCodeData,
      this.qrHormonyCodeOptions,
      function (error) {
        if (error) console.error(error)
      }
    );
  }
};
</script>
<style lang="less" scoped>
.mxMobileContent {
  padding-top: 50px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  position: relative;
  height: 100%;
  box-sizing: border-box;

  .content-top {
    display: flex;
    flex-direction: column;
    .title {
      font-size: 32px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #191919;
      line-height: 48px;
    }
    .desc {
      margin-top: 4px;
      font-size: 16px;
      color: #666666;
      line-height: 24px;
    }
    .code-container {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 40px;

      .harmony-code {
        height: 160px;
        width: auto;
        object-fit: scale-down;
      }
      .mxScanIcon {
        width: 44px;
        height: 44px;
        position: absolute;
        background: #fff;
        z-index: 50;
      }
    }
    // .qrcode_download {
    //   margin-top: 28px;
    //   position: relative;
    //   z-index: 49;
    //   display: flex;
    //   align-items: center;
    //   justify-content: center;
    //   padding: 10px;
    //   background-color: #ffffff;
    //   .group-code {
    //     width: 156px;
    //     height: auto;
    //     object-fit: scale-down;
    //   }
    //   .qrcode_icon {
    //     position: absolute;
    //     z-index: 50;
    //     width: 46px;
    //     height: 46px;
    //   }
    // }

    .scan-hint {
      line-height: 22px;
      text-align: center;
      color: #191919;
      margin-top: 12px;
      // font-family: 苹方-简;
      font-size: 14px;
      font-weight: normal;
      letter-spacing: 0px;
      opacity: 0.8738;
      margin-bottom: 40px;
    }
    .common-btn {
      width: 180px;
      height: 44px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 16px;
      font-weight: 500;
      border-radius: 8px;
      margin: 0 auto;
    }
    .android-download {
      border: 0.5px solid #2496FF;
      color: #2496FF;
    }
    .harmony-download {
      color: #FFFFFF;
      background: #2496FF;
      margin-top: 12px;
      margin-bottom: 12px;
    }
    .remark {
      font-size: 14px;
      line-height: 22px;
      color: #8D8D8D;
      text-align: center;
    }
  }
  .add-group {
    font-size: 14px;
    line-height: 22px;
    text-align: center;
    letter-spacing: 0px;
    padding: 102px 0 50px;
    color: #2496FF;

  }
  // .group-hint {
  //   line-height: 24px;
  //   text-align: center;
  //   color: #666666;
  //   margin-top: 24px;
  // }
  .group-num {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 4px;
    color: #666666;
    line-height: 24px;
    .copy-btn {
      margin-left: 12px;
      width: 20px;
      height: 20px;
      cursor: pointer;
    }
  }
}
.el-dialog {
  border-radius: 20px !important;
  .dialog_content {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;

    .qrcode_group {
      position: relative;
      z-index: 49;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 10px;
      background-color: #ffffff;
      border: 2px solid #F5F5F5;
      border-radius: 12px;

      .group-code {
        width: 156px;
        height: auto;
        object-fit: scale-down;
      }
      .qrcode_icon {
        position: absolute;
        z-index: 50;
        width: 46px;
        height: 46px;
      }
    }
  }
  .tips {
    white-space: pre-wrap;
    font-size: 14px;
    font-weight: 500;
    line-height: 22px;
    text-align: center;
    letter-spacing: 0px;
    /* 中性灰/灰色7_主要文字 */
    color: #191919;
    margin-bottom: 24px;
  }
}
</style>

<style lang="less">
.mxMobileContent .el-dialog {
  border-radius: 20px !important;
}
</style>
